<ng-template #displayTemplateRef
             let-cellData
             let-rowData="rowData">

  @if (isClickable(rowData)) {
    <a [pRowToggler]="rowData"
       (click)="expandClicked(rowData)">{{getCellValue(cellData)}}</a>
  }

  @if (!isClickable(rowData)) {
    <span>{{getCellValue(cellData)}}</span>
  }
</ng-template>